<template>
	<div class="container-fluid bg-white">
		<expense-toolbar heading="Expenses"></expense-toolbar>

		<expense-table
			:show-user="true"
			:show-job="true"
			:editable="true"
			:filtering-tools="true">
		</expense-table>

	</div>
</template>

<script>
import ExpenseTable from "../components/super_components/ExpenseTable"
import ExpenseToolbar from "./expenses/ExpenseToolbar"

export default {

	name: 'Expenses',
	components: {
		ExpenseToolbar,
		ExpenseTable
	}

}
</script>
